import React from 'react';
import {MdCheckbox, MdTextField} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import {FormProps, lovLabel, lovValue} from 'core/form/formUtils';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {Validate} from 'core/form/validate';
import {observer} from "mobx-react";
import {Shipment, SHIPMENTDIRECTION, ShipmentVisit, SHIPMENTVISITSTEP} from "shipment/shipmentDomain";
import {FIELDDEFSIZE} from "core/form/form";
import {action, observable} from "mobx";
import {loc} from "core/common/config/locales";
import {CountryPhoneFormat} from "core/form/rules";
import {PHONE_PATTERN} from "core/common/utils/constant";
import shipmentService from "shipment/shipmentService";
import StyledSelect from 'core/components/fields/styledSelect';
import {optionsSearch} from "core/common/service/commonDataService";
import MdField, {VALUESOURCETYPE} from 'core/metamodel/mdField';
import {blue500, grey500, grey900, red500} from "material-ui/styles/colors";
import uiService from "core/common/service/uiService";
import {SecuredZzRaisedButton, ZzFlatButton} from "core/components/buttons/buttons";
import {PERMISSION, SECURABLE} from "core/metamodel/metaConstant";
import {PARTYROLE} from "party/partyDomain";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "core/form/closedForm";
import {formatDateIso} from "core/common/utils/dateUtils";
import {BigFlagBar} from "shipment/component/shipmentVisitComps";
import Grid, {FILTEROPERATOR} from "core/grid/domain/grid";

import SelectSearchDialog from "core/components/fields/selectSearchDialog";
import GridConfigCondition from "core/grid/domain/gridConfigCondition";
import PropTypes from "prop-types";
import RadioButtonField from "core/components/fields/radioButtonField";
import {LovItem} from "core/metamodel/mdEntity";
import FlatButton from "material-ui/FlatButton";
import GridComp, {UILOCATION} from "core/grid/component/gridComp";
import mdEntityService from "core/metamodel/mdEntityService";

const visitNewShipmentGridLocation = 'visitNewShipmentList';


export const ShipmentVisitClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<ShipmentVisit>) => (
  <ClosedFormBlock {...{dataObject, entity, entities, fields}} >
    <ClosedFormField label='ID' value={dataObject.shipmentVisitId} linkProps={{to: 'shipmentVisitDetail', params: {id: dataObject.shipmentVisitId}}}/>
    <ClosedFormField label={fields.registrationNumber.textLabel} value={dataObject.registrationNumber}/>
    <ClosedFormField label={fields.driverPhone.textLabel} value={dataObject.driverPhone}/>
    <ClosedFormField label={fields.visitTime.textLabel} value={dataObject.visitTime} mdField={fields.visitTime.mdField}/>
    <ClosedFormField label={fields.entranceTime.textLabel} value={dataObject.entranceTime} mdField={fields.entranceTime.mdField}/>
    <ClosedFormField label={fields.visitEnd.textLabel} value={dataObject.visitEnd} mdField={fields.visitEnd.mdField}/>
    <ClosedFormField label={fields.gateLoadingDuration.textLabel} value={dataObject.gateLoadingDuration} mdField={fields.gateLoadingDuration.mdField}/>
    <ClosedFormField label={fields.vendorLoadingDuration.textLabel} value={dataObject.vendorLoadingDuration} mdField={fields.vendorLoadingDuration.mdField}/>
    <ClosedFormField label={fields.directionOutgoing.textLabel} value={dataObject.directionOutgoing}/>
    <ClosedFormField label={fields.directionPackaging.textLabel} value={dataObject.directionPackaging}/>
    <ClosedFormField label={fields.directionIncoming.textLabel} value={dataObject.directionIncoming}/>
    <ClosedFormField label={fields.packagingSender.textLabel} value={dataObject.packagingSender}/>
  </ClosedFormBlock>
);


@createForm({
  formName: 'ShipmentVisitDriverForm',
  fields: [{
    name: 'registrationNumber',
    validators: ['IsRequired'],
    size: FIELDDEFSIZE.huge
  }, {
    name: 'visitTime'
  }, {
    name: 'visitEnd'
  }, {
    name: 'driverPhone',
    validators: ['IsRequired'],
    size: FIELDDEFSIZE.huge
  },  {
    name: "directionPackaging"
  }, {
    name: "directionOutgoing"
  }, {
    name: "directionIncoming"
  }, {
    name: "$supplierId",
    mdField: new MdField({label: 'Supplier', valueSourceType: VALUESOURCETYPE.ASYNC}),
    size: FIELDDEFSIZE.huge
  }, {
    name: "packagingSender",
    size: FIELDDEFSIZE.huge
  }, {
    name: "entranceTime"
  }, {
    name: "gateLoadingDuration"
  }, {
    name: "vendorLoadingDuration"
  }]
}, ShipmentVisitClosedContent)
@observer
export default class ShipmentVisitDriverForm extends React.Component<FormProps<ShipmentVisit, ShipmentVisit>, undefined> {

  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  private allShipments: Shipment[] = [];

  @observable newInicialized: boolean = false;

  @observable showSenderSelectBox: boolean = false;
  currentTime: String = new Date().toISOString();

  private selectSearchDialogRef: SelectSearchDialog;
  selectSearchDialogRefHandler = (comp) => this.selectSearchDialogRef = comp;


  componentWillMount(): void {
    this.showSenderSelectBox = !!this.props.dataObject.packagingSender;
    this.setPlus(this.props.dataObject);
  };

  componentDidUpdate(prevProps: Readonly<FormProps<ShipmentVisit, ShipmentVisit>>, prevState: Readonly<undefined>, prevContext: any) {
    console.log("componentDidUpdate");
    this.setPlus(this.props.dataObject);
  }

  @action setPlus(dataObject: ShipmentVisit) {
    console.log("setPlus 1 ", dataObject.driverPhone);
    if (!dataObject.driverPhone) {
      dataObject.driverPhone = "+";
      this.props.form.updateFieldsPropValue(dataObject, "driverPhone");
      console.log("setPlus 2 ", dataObject.driverPhone);
    }
  }

  @action onSubmit = (e) => {
    console.log('form submited');
    e.preventDefault();
    let {dataObject, onSubmit, entities} = this.props;


    return onSubmit(dataObject, () => {
      let shipmentVisitStepEntity = entities.get("SHIPMENTVISITSTEP");
      dataObject.step = shipmentVisitStepEntity.getLovItem(SHIPMENTVISITSTEP.VEHICLE_ARRIVED);
      dataObject.visitTime = new Date().toISOString();
    }).then(() => {

    });
  };

  render() {


    let {dataObject, rootObject, entity, entities, form, formName} = this.props;
    let fields = form.fields;
    let {
      registrationNumber, driverPhone,  directionPackaging, $supplierId, packagingSender, entranceTime
    } = dataObject.getFormFields(formName);

    let shipmentdirectionEntity = entities.get("SHIPMENTDIRECTION");


    return (

      <form style={{marginTop: 10, display: "flex", flexDirection: "column"}} onSubmit={this.onSubmit} autoComplete="off">
        <SelectSearchDialog ref={this.selectSearchDialogRefHandler} gridLocation="shipmentVisitSearch" showGridConfig={false} title="Select Shipment Visit" contentStyle={{width: '80%', maxWidth: 1280}}/>
        <BigFlagBar/>

        <BlockComp>
          <div className="row">
            <div className="fx col-xs-12 col-sm-6">
              <MdTextField {...registrationNumber.props} disabled={!dataObject.$new} floatingLabelFixed={true}
                           floatingLabelStyle={{...registrationNumber.props.floatingLabelStyle, fontSize: 35, color: grey900}} autoComplete="off"/>
              <Validate field={registrationNumber} value={registrationNumber.props.value} onSuccess={this.handleSuccessRegistrationNumber}/>
            </div>
            {(!dataObject.$new || this.newInicialized) && (
              <div className="fx col-xs-12 col-sm-6">
                <MdTextField {...driverPhone.props} floatingLabelFixed={true} floatingLabelStyle={{...driverPhone.props.floatingLabelStyle, fontSize: 35, color: grey900}}
                             autoComplete="off"/>
                <Validate field={driverPhone} value={driverPhone.props.value}>
                  <CountryPhoneFormat pattern={PHONE_PATTERN}/>
                </Validate>
              </div>
            )}
          </div>


          {/* ************  DIRECTION  *************/}
          {
            (dataObject.$new && this.newInicialized) && (
              <div className="row">
                <div className="col-xs-12">
                  <RadioButtonField value={dataObject.$direction} onChange={this.handleDirectionChange} options={shipmentdirectionEntity.lovItems}
                                    style={{marginTop: 20}}
                                    groupStyle={{display: 'flex', height: 50, justifyContent: "center"}}
                                    optionStyle={{width: 'initial', marginRight: 15, fontSize: 25, height: 40}}
                                    labelStyle={{whiteSpace: 'nowrap', marginLeft: -10}}
                                    iconStyleFn={v => ({fill: v === SHIPMENTDIRECTION.OUTGOING ? blue500 : red500, height: 30, width: 30})}/>
                </div>
              </div>
            )
          }

          {
            (!dataObject.$new) && (
              <div className="row">
                <div className="fx col-xs-12" style={{justifyContent: "center"}}>
                  <span style={{fontSize: 25, color: grey500}}>{lovLabel(dataObject.$direction)} Visit </span>
                </div>
              </div>
            )}


          {/* ************  SUPPLIER  *************/}
          {(lovValue(dataObject.$direction) === SHIPMENTDIRECTION.INCOMING) && dataObject.$new &&
            <div className="row" style={{marginTop: 10}}>
              <div className="fx col-xs-12">
                <StyledSelect {...$supplierId.props} disabled={!dataObject.$new} floatingLabelText={loc.i18n`Supplier`}
                              async={true} clearable={true} asterixForAll floatingLabelStyle={{...$supplierId.props.floatingLabelStyle, fontSize: 35, color: grey900}}
                              loadOptions={optionsSearch.bind(this, lovValue('Shipment'), {potentialSuppliers: true, visitTime: this.currentTime})}/>
                <Validate field={$supplierId} value={$supplierId.props.value} onSuccess={this.handleSupplier}/>
              </div>
            </div> }


          {/* ************  PACKAGING & SENDER  *************/}
          {(lovValue(dataObject.$direction) === SHIPMENTDIRECTION.OUTGOING) && (
            <div className="row">
              <div className="fx col-xs-4" style={{alignSelf: "center"}}>
                <MdCheckbox {...directionPackaging.props} onCheck={this.handleDirectionPackaging}
                            style={{height: 30, width: 'auto', marginRight: 20, marginTop: 20}} labelStyle={{whiteSpace: 'nowrap', fontSize: 25, color: grey900}}/>
              </div>
              {
                (dataObject.directionPackaging) && (
                  <div className="fx col-xs-8">
                    <StyledSelect {...packagingSender.props}
                                  async={true} clearable={true} asterixForAll floatingLabelText={loc.i18n`shipment.packagingSender`}
                                  loadOptions={optionsSearch.bind(this, lovValue('Party'), {role: [PARTYROLE.PACKAGING]})}/>
                    <Validate field={packagingSender} value={packagingSender.props.value}/>
                  </div>
                )
              }
            </div>
          )}


          {/* ************  SHIPMENT GRID  *************/}
          {dataObject.$direction && (
            <div style={{marginTop: 20}}>
              <GridComp ref={visitNewShipmentGridLocation}
                        grid={dataObject.$shipmentVisitShipmentsGrid}
                        uiLocation={UILOCATION.main}
                        entities={mdEntityService.entityMap}
                        rootObject={dataObject}
                        hideToolbar/>
            </div>
          )}



          {(dataObject.$direction) ? (
            <div className="row" style={{marginTop: 20}}>
              <div className="fx col-xs-10">
                <SecuredZzRaisedButton type="submit" label={loc.i18n`Save`} disabled={!dataObject.registrationNumber || !dataObject.driverPhone || uiService.getToolbarActionFlag()}
                                       permission={PERMISSION.New} securable={SECURABLE.shipmentVisitDetail}
                                       secondary={true} style={{height: 60, width: 140}} labelStyle={{fontSize: 20}}/>
                { !dataObject.$new && <FlatButton label={loc.i18n`Reset`} disabled={uiService.getToolbarActionFlag()} onClick={this.newVisit}
                                       primary={true} style={{height: 60, width: 140, marginLeft: 20}} labelStyle={{fontSize: 20}}/>}

              </div>
            </div>
          ) : null}


        </BlockComp>

      </form>

    )
  }


  @action handleDirectionPackaging = (evt) => {
    let {entities, dataObject, form, rootObject} = this.props;
    form.getField("directionPackaging").props.onCheck(evt);
    if (!dataObject.directionPackaging) {
      dataObject.packagingSender = undefined;
      form.updateFieldsPropValue(dataObject, "packagingSender");
    }
  }


  @action handleSupplier = () => {
    let {entities, dataObject, form, rootObject} = this.props;
    if (dataObject.$supplierId) {
      return shipmentService.readShipments(undefined, formatDateIso(new Date()), FILTEROPERATOR.LESSOREQUALTHAN, dataObject.$supplierId.value, SHIPMENTDIRECTION.INCOMING, dataObject, true)
        .then(action("readShipments-acb", (shipments: Shipment[]) => {
          dataObject.shipments = shipments;
          return shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService.shipmentVisitObject);
        }))
    } else {
      dataObject.shipments = this.allShipments.filter(s => s.shipmentDirection === lovValue(dataObject.$direction));
      return shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService.shipmentVisitObject);
    }
  };


  @action handleSuccessRegistrationNumber = () => {
    let {entity, dataObject, form, rootObject, entities} = this.props;
    let shipmentdirectionEntity = entities.get("SHIPMENTDIRECTION");
    console.debug('handleSuccessRegistrationNumber %s - valid %s', dataObject.registrationNumber);

    shipmentService.readShipmentVisits(dataObject.registrationNumber, null, null, null, null, null, SHIPMENTVISITSTEP.PREPARED_VISIT)
      .then(action("readShipmentVisits-cb", (visits: ShipmentVisit[]) => {
        if (visits.length === 1) {
          console.log("handleSuccessRegistrationNumber - found one visit %o", visits[0]);
          rootObject.$dirty = false;
          this.context.router.transitionTo("shipmentVisitDetail", {id: visits[0].shipmentVisitId});
        } else if (visits.length > 1) {
          console.log("handleSuccessRegistrationNumber - found more than 1 visit %o", visits);
          new Promise((resolve, reject) => {
            return this.selectSearchDialogRef.open(resolve, reject, (grid: Grid) => {
              if (!grid.conditionArray) grid.conditionArray = [];
              grid.conditionArray.push(new GridConfigCondition(grid.$gridLocationRef, {
                field: entity.getField("registrationNumber"),
                operator: FILTEROPERATOR.EQUAL,
                values: [dataObject.registrationNumber]
              }));
              grid.conditionArray.push(new GridConfigCondition(grid.$gridLocationRef, {
                field: entity.getField("step"),
                operator: FILTEROPERATOR.EQUAL,
                values: [SHIPMENTVISITSTEP.PREPARED_VISIT]
              }));

            });
          }).then(action("close-new-party-diaglog", (visit: ShipmentVisit) => {
            console.log("handleSuccessRegistrationNumber - selected %o", visit);
            rootObject.$dirty = false;
            this.context.router.transitionTo("shipmentVisitDetail", {id: visit.shipmentVisitId});
          })).catch((e) => {
          });
        } else {
          // not found
          console.log("handleSuccessRegistrationNumber - not found");
          return shipmentService.readShipments(dataObject.registrationNumber, formatDateIso(new Date()), FILTEROPERATOR.LESSOREQUALTHAN, undefined, null, dataObject, false)
            .then(action("readShipments-acb", (shipments: Shipment[]) => {
              console.log("handleSuccessRegistrationNumber - not found - readShipments %o", shipments);
              dataObject.$supplierId = null;
              dataObject.directionPackaging = false;
              dataObject.directionOutgoing = false;
              dataObject.directionIncoming = false;
              dataObject.$direction = undefined;
              form.updateFieldsPropValue(dataObject, "$supplierId", "directionPackaging");

              this.newInicialized = true;
              this.allShipments = shipments;

              let outgoingShipments = shipments.filter(s => s.shipmentDirection === SHIPMENTDIRECTION.OUTGOING);
              let incomingShipments = shipments.filter(s => s.shipmentDirection === SHIPMENTDIRECTION.INCOMING);

              if (outgoingShipments.length > 0) {
                dataObject.$direction = shipmentdirectionEntity.getLovItem(SHIPMENTDIRECTION.OUTGOING);
                dataObject.directionOutgoing = true;
                dataObject.shipments = outgoingShipments;
              } else if (incomingShipments.length > 0) {
                dataObject.$direction = shipmentdirectionEntity.getLovItem(SHIPMENTDIRECTION.INCOMING);
                dataObject.directionIncoming = true;
                dataObject.shipments = incomingShipments;
              } else {
                dataObject.shipments = [];
              }

              return shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService.shipmentVisitObject);
            }));
        }
      }));
  }

  @action handleDirectionChange = (newLov: LovItem<SHIPMENTDIRECTION>) => {
    const {dataObject, form} = this.props;
    dataObject.$direction = newLov;
    dataObject.directionOutgoing = (lovValue(newLov) === SHIPMENTDIRECTION.OUTGOING);
    dataObject.directionIncoming = (lovValue(newLov) === SHIPMENTDIRECTION.INCOMING);
    dataObject.directionPackaging = false;
    dataObject.$supplierId = null;
    dataObject.shipments = this.allShipments.filter(s => s.shipmentDirection === lovValue(newLov));
    form.updateFieldsPropValue(dataObject, "$supplierId", "directionPackaging");

    return shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService.shipmentVisitObject);
  }

  newVisit = (evt) => {
    this.newInicialized = false;
    this.context.router.transitionTo("shipmentVisitDetail", {id: 'new'}, {});
  };



}




// WEBPACK FOOTER //
// ./src/shipment/component/shipmentVisitDriverForm.tsx